import React from 'react';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { ConnectedRecentsSpace } from './ConnectedRecentsSpace';

export interface RecentsSpaceProviderProps extends ReactDirectiveProps {
  readonly siteName: string;
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

const RecentsSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'recents',
  subspaceName: undefined
};

export const RecentsSpaceProvider: React.FunctionComponent<RecentsSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo= {RecentsSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <ConnectedRecentsSpace
          angularContext={props.angularContext}
          siteName={props.siteName}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
